import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { StateProps } from 'Container/App/interface';
import { getDeviceSubline } from 'Container/App/helpers/getDeviceSubline';
import { replacePlaceholders } from '@vfde-sails/utils';

/**
 * Get headline
 */
export const getHeadline = ({ activeOffer, dataVolume }: Pick<StateProps, 'activeOffer' | 'dataVolume'>): string | undefined => {
    const { tariffInfoPattern } = window[ADDITIONAL_PAGE_OPTIONS].offerSummaryCard || {};

    if (!activeOffer || !tariffInfoPattern || !dataVolume) {
        return;
    }

    return replacePlaceholders(tariffInfoPattern, {
        name: activeOffer.tariffName,
        amount: dataVolume.unlimited ? window[ADDITIONAL_PAGE_OPTIONS].offerSummaryCard.unlimitedDataVolume : `${dataVolume.value.toLocaleString('de-DE')} ${dataVolume.unit}`,
    });
};

/**
 * Get headline
 */
export const getSubline = (state: Pick<StateProps, 'device' | 'customerConfig'>): string | undefined => {
    const { device: hardware } = state;
    const deviceName = hardware && hardware.modelName;
    const { offerSummaryCard } = window[ADDITIONAL_PAGE_OPTIONS];

    return deviceName ? getDeviceSubline(state, true) : offerSummaryCard.noDeviceText;
};

/**
 * compose legal text of offer price
 */
export const composeLegalText = ({ activeOffer }: Pick<StateProps, 'activeOffer'>): string | null => {
    const { contractRuntimePattern, oneTimeFeePattern } = window[ADDITIONAL_PAGE_OPTIONS].offerSummaryCard || {};

    if (!activeOffer || !contractRuntimePattern || !oneTimeFeePattern) {
        return null;
    }

    if (!activeOffer.priceConnectionFee) {
        return `${oneTimeFeePattern} ${contractRuntimePattern}`;
    }

    return contractRuntimePattern;
};

/**
 * create tooltip id for highlight badge tooltip
 */
export const createTooltipId = (activeOffer: StateProps['activeOffer'], hasGigakombi: boolean): string => {
    let id = `highlight-badge-tooltip-${activeOffer!.tariffId}`;

    if (hasGigakombi) {
        id = `${id}-gk`;
    }

    return id;
};
